export const InquiriesConstants = {
    GET_INQUIRIES_REQUEST: 'GET_INQUIRIES_REQUEST',
    GET_INQUIRIES_SUCCESS: 'GET_INQUIRIES_SUCCESS',
    GET_INQUIRIES_FAIL: 'GET_INQUIRIES_FAIL',
}